import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router';

import { REQUIRED_PRESIGN_PARAMS } from '@/shared/config/constants';
import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { authModel } from '@/entities/auth';

export const useIsPresignMode = (): boolean => {
  const [searchParams] = useSearchParams();
  const dispatch = useAppDispatch();

  const isReportLimitedSession: boolean = useAppSelector(
    authModel.selectors.selectIsReportLimitedSession,
  );

  const isPresignSession: boolean = useAppSelector(
    authModel.selectors.selectIsPresignSession,
  );

  const hasPresignParams = useMemo(
    () => REQUIRED_PRESIGN_PARAMS.every((param) => searchParams.has(param)),
    [searchParams],
  );
  useEffect(() => {
    if (hasPresignParams) {
      dispatch(authModel.actions.setPresignSession(true));
    }
  }, [hasPresignParams, dispatch]);

  return isReportLimitedSession || hasPresignParams || isPresignSession;
};
